// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"amount-currency_wrapper__ox1F5","input":"amount-currency_input__1hVz9"};